const resourceStatusBadge = (value) => {

    if (value == null || value === "") {
        return <span className="text-muted">—</span>
    }

    const display = String(value).trim()
    let wrapClass = "table-sb-inactive"
    let dotClass = "dot-icon-inactive"

    switch (display.toLowerCase()) {
        case "available":
            wrapClass = "table-sb-active"
            dotClass = "dot-icon-active"
            break
        case "not available":
            wrapClass = "table-sb-inactive"
            dotClass = "dot-icon-inactive"
            break
        case "maintenance":
            wrapClass = "table-sb-high"
            dotClass = "dot-icon-high"
            break
        default:
            break
    }

    return (
        <span className={`badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 ${wrapClass}`}>
            <span className={`dot-icon rounded-circle ${dotClass}`} />
            {display}
        </span>
    )
}

export default resourceStatusBadge;